import actions from '@/core/store/ata/documentos-ata/processo-digital/desentranhamento/actions'

export default {
	actions,
}
